export default {
  rankOrder: {
    ariaAddOption: 'Adicionar {label} à lista classificada',
    ariaMoveUp: 'Mover {label} para cima',
    ariaMoveDown: 'Mover {label} para baixo',
    ariaRemoveOption: 'Remover {label} da lista classificada',
  },
  coe: {
    ariaDisclaimer: 'Aviso',
    ariaQuestion: 'Pergunta',
    ariaConversationHistory: 'Histórico da conversa',
    ariaYourResponse: 'Sua resposta {number}',
    ariaFollowUpQuestion: 'Pergunta de acompanhamento {number}',
    ariaResponseInput: 'Campo de resposta',
    ariaRespondingTo: 'Respondendo a',
    ariaSendResponse: 'Enviar resposta',
    ariaThinking: 'Pensando'
  },
  deviceView: {
    toolbar: 'Dispositivo de pré-visualização',
    mobile: 'Celular',
    tablet: 'Tablet',
    desktop: 'Computador'
  },
  header: {
    customLogoAlt: 'Logotipo',
    defaultLogoAlt: 'Logotipo QuestDIY'
  }
}
